var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"title"},[_vm._v("选择灰鲸聚合SDK 收益增长更快一步")]),_vm._v(" "),_c('div',{staticClass:"btn-box",on:{"click":function($event){return _vm.goUrl('https://admin.huimiaokeji.com')}}},[_c('div',{staticClass:"btn"},[_vm._v("马上注册")])]),_vm._v(" "),_c('div',{staticClass:"footer-copyright-box"},[_vm._v(" 浙ICP备2024075097号 Copyright © 2025 杭州灰喵科技有限公司. AII Rights Reserved")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52858956","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer-menu.vue
// module id = 279
// module chunks = 1